/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Register_Onboarding_Select_Other_Jobs_Intro_TitleInputs */

const en_register_onboarding_select_other_jobs_intro_title = /** @type {(inputs: Register_Onboarding_Select_Other_Jobs_Intro_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your matching score for other positions is:`)
};

const de_register_onboarding_select_other_jobs_intro_title = /** @type {(inputs: Register_Onboarding_Select_Other_Jobs_Intro_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Matching Score für weitere Positionen ist:`)
};

/**
* | output |
* | --- |
* | "Your matching score for other positions is:" |
*
* @param {Register_Onboarding_Select_Other_Jobs_Intro_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const register_onboarding_select_other_jobs_intro_title = /** @type {((inputs?: Register_Onboarding_Select_Other_Jobs_Intro_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Register_Onboarding_Select_Other_Jobs_Intro_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_register_onboarding_select_other_jobs_intro_title(inputs)
	return en_register_onboarding_select_other_jobs_intro_title(inputs)
});